import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "@/App.css";
import PatronApp from "./pages/PatronApp";
import ChefApp from "./pages/ChefApp";
import ScanBonPublic from "./pages/ScanBonPublic";
import ScanUnifie from "./pages/ScanUnifie";
import ScanApp from "./pages/ScanApp";
import CartePrint from "./pages/patron/CartePrint";
import ResponsablePage from "./pages/ResponsablePage";
import RoueDuMas from "./pages/RoueDuMas";
import BookingPage from "./pages/public/BookingPage";
import CancelPage from "./pages/public/CancelPage";
import HomePage from "./pages/public/HomePage";
import AdminHub from "./pages/public/AdminHub";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import EmployeApp from "./pages/EmployeApp";
import { RestaurantHome, RestaurantMenu, RestaurantContact, RestaurantAbout, RestaurantGalerie, RestaurantGroupe } from "./pages/public/RestaurantSite";
import { TraiteurHome, TraiteurPrestations, TraiteurPlateaux, TraiteurGalerie, TraiteurContact } from "./pages/public/TraiteurSite";
import { BonsCadeauxShop, BonsCadeauxConfirmation } from "./pages/public/BonsCadeauxPublic";
import { Toaster } from "./components/ui/sonner";
import { ThemeProvider } from "./hooks/useTheme";

// Subdomain-based root redirect: lets `direction.`, `commercial.`, `cuisine.` open the right module.
function RootRedirect() {
  const host = typeof window !== "undefined" ? window.location.hostname.toLowerCase() : "";
  const sub = host.split(".")[0];
  if (sub === "direction" || sub === "patron") {
    return <Navigate to="/patron" replace />;
  }
  if (sub === "commercial") {
    return <Navigate to="/patron/propositions" replace />;
  }
  if (sub === "cuisine" || sub === "chef") {
    return <Navigate to="/chef" replace />;
  }
  return <HomePage />;
}

function App() {
  return (
    <HelmetProvider>
    <ThemeProvider>
      <div className="App min-h-screen bg-lemas-bg transition-colors duration-300">
        <BrowserRouter>
          <Routes>
            {/* Public Homepage Splitter — redirects to right module based on subdomain */}
            <Route path="/" element={<RootRedirect />} />

            {/* Admin Hub - Centre de Gestion */}
            <Route path="/hub" element={<AdminHub />} />

            {/* PWA shortcut routes - same as portals but with dedicated paths */}
            <Route path="/app-patron" element={<Navigate to="/hub" replace />} />
            <Route path="/app-patron.html" element={<Navigate to="/hub" replace />} />
            <Route path="/app-chef" element={<Navigate to="/chef" replace />} />
            <Route path="/app-chef.html" element={<Navigate to="/chef" replace />} />
            <Route path="/app-scan" element={<Navigate to="/patron" replace />} />
            <Route path="/app-scan.html" element={<Navigate to="/patron" replace />} />
            <Route path="/app-commercial" element={<Navigate to="/patron" replace />} />
            <Route path="/app-commercial.html" element={<Navigate to="/patron" replace />} />

            {/* Restaurant public pages */}
            <Route path="/site/restaurant" element={<RestaurantHome />} />
            <Route path="/site/restaurant/menu" element={<RestaurantMenu />} />
            <Route path="/site/restaurant/galerie" element={<RestaurantGalerie />} />
            <Route path="/site/restaurant/a-propos" element={<RestaurantAbout />} />
            <Route path="/site/restaurant/contact" element={<RestaurantContact />} />
            <Route path="/site/restaurant/groupe" element={<RestaurantGroupe />} />
            <Route path="/site/restaurant/bons-cadeaux" element={<BonsCadeauxShop />} />
            <Route path="/site/restaurant/bons-cadeaux/confirmation" element={<BonsCadeauxConfirmation />} />

            {/* Traiteur public pages */}
            <Route path="/site/traiteur" element={<TraiteurHome />} />
            <Route path="/site/traiteur/prestations" element={<TraiteurPrestations />} />
            <Route path="/site/traiteur/plateaux" element={<TraiteurPlateaux />} />
            <Route path="/site/traiteur/galerie" element={<TraiteurGalerie />} />
            <Route path="/site/traiteur/contact" element={<TraiteurContact />} />
            <Route path="/site/traiteur/devis" element={<TraiteurContact />} />

            {/* Reservation */}
            <Route path="/reservation" element={<BookingPage />} />
            <Route path="/reservation/annuler/:id" element={<CancelPage />} />

            {/* Auth */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />

            {/* Admin portals */}
            <Route path="/patron/*" element={<PatronApp />} />
            <Route path="/chef/*" element={<ChefApp />} />
            <Route path="/employe" element={<EmployeApp />} />
            <Route path="/responsable" element={<ResponsablePage />} />

            {/* Tools */}
            <Route path="/carte-print" element={<CartePrint />} />
            <Route path="/scan-bon" element={<ScanBonPublic />} />
            <Route path="/scan" element={<ScanUnifie />} />
            <Route path="/scan-app" element={<ScanApp />} />
            <Route path="/roue" element={<RoueDuMas />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </div>
    </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
